import { CVEFindingsNode } from "~/pages/inventory/components/AssetSoftwareDetails/AssetSoftwareVulnerabilities/hooks/types";
import { AdvisoryFindingsNode } from "~/pages/inventory/components/Findings/FindingsTable/utils/advisoryTypes";
import { CheckFindingsCheckNode } from "~/pages/inventory/asset/types";
import { AggregateScoresNode } from "~/components/FirewatchPage";
import { AggregateScoreType } from "~/operations";
import { ExposedAsset } from "~/pages/space/vulnerabilities/components/exposed-assets/types";
import { isAggregateScore } from "~/components/FirewatchPage/utils/typeguard";

export const allowedFindingTypes = ["AdvisoryFinding", "CveFinding"];
const allowedAggregateTypes = [
  AggregateScoreType.Advisory,
  AggregateScoreType.Vulnerability,
];

export function isRemediationWorkflowSupported(
  finding:
    | CVEFindingsNode
    | AdvisoryFindingsNode
    | CheckFindingsCheckNode
    | AggregateScoresNode
    | ExposedAsset,
) {
  //We currently allow fix forever pipeline on AggregateScore Advisories and Vulnerabilities
  if (
    isAggregateScore(finding) &&
    allowedAggregateTypes.includes(finding.scoreType)
  ) {
    return true;
  }

  // We also allow on Finding Advisories and Vulnerabilities
  if (allowedFindingTypes.includes(finding.__typename)) {
    return true;
  }

  // everything else is currently blocked
  return false;
}
